import { clearAuthCookies } from "@utils/access-token-cookie";
import { clearImpersonationMarker } from "@shared-kernel/core/impersonation/impersonation-marker";

export const terminateSession = (): void => {
  clearAuthCookies();
  clearImpersonationMarker();
};
